import { render, staticRenderFns } from "./CommunicationsInbox.vue?vue&type=template&id=0d850bf8&"
import script from "./CommunicationsInbox.vue?vue&type=script&lang=js&"
export * from "./CommunicationsInbox.vue?vue&type=script&lang=js&"
import style0 from "./CommunicationsInbox.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports